// extracted by mini-css-extract-plugin
module.exports = {"o17cm9sw":"o17cm9sw"};